import { ErrorHandler, Injectable } from '@angular/core';

import * as Raven from 'raven-js';

import { environment } from '../environments/environment'

if (environment.production) {
	Raven.config('https://b8f22ea76ad4477ba17eddeb5218ec15@logger.go-suite.com/8', {
		environment: environment.production ? 'production' : 'development',
		release: '<% RELEASE %>',
	}).install();
}

@Injectable()
export class RavenErrorHandler implements ErrorHandler {
	handleError(err: any): void {
		if (!environment.production) {
			console.error(err);
			return;
		}

		Raven.captureException(err.originalError || err);
	}
}



// WEBPACK FOOTER //
// ./src/app/error-handler.ts